import { createConfig, extendConfig } from '@platform-shared/config';

/**
 * VTC-specific configuration that extends and overrides the shared config
 */
const vtcConfig = {
  atatus: {
    install: true,
    token: '6b375cbbccff41edaa688b4d8e064b12',
  },
  // VTC-specific settings
  mode: 'remote',
  authentication: {
    localStorageToken: 'sp_token',
    localStorageRoomSid: 'sp_room',
  },
  media: {
    microphone: {
      localStorageToken: "vtc_audio_input_device",
    },
    speaker: {
      localStorageToken: "vtc_audio_output_device",
    }
  },
  featureFlags: {
    enableNewUI: true,
    enableBetaFeatures: false,
  },
  modes: {
    checkin: {
      drawerWidth: '375px',
    },
    focus: {
      drawerWidth: '60%',
    },
    settings: {
      drawerWidth: '500px',
    },
    options: {
      drawerWidth: '400px',
    },
  },
};

/**
 * Merge the shared config with the VTC-specific config
 * The VTC config will override any shared config values with the same keys
 */
const baseConfiguration = createConfig(import.meta.env.VITE_MODE);
const config = extendConfig('vtc', vtcConfig, baseConfiguration);

export const API_PATHS = {
  LIST_ROOMS: '/v1/hybrid/locations/rooms',
  ROOMS: '/v1/hybrid/locations/rooms/:roomSid',
  ACTIVE_PROCTORS: '/v1/hybrid/locations/rooms/:roomSid/proctors`',
  LOGIN: '/v1/proctors/login',
  TTL: '/v1/ttl',
  EXTEND_TTL: '/v1/check',
  TOKEN_PERMISSIONS: '/v1/permissions',
  PROCTOR_ACCOUNT: '/v1/proctors/:accountSid',
  ANNOTATIONS:
    '/v1/installs/:installSid/exams/:examSid/sessions/:sessionSid/annotations',
  ROOMS_FOR_TRANSFER:
    '/v1/hybrid/installs/:installSid/exams/:examSid/sessions/:sessionSid/availableRoomsToTransfer?proctorRoomSid=:roomSid',
  TRANSFER_SESSION:
    '/v2/installs/:installSid/exams/:examSid/sessions/:sessionSid/transfer',
  JOIN_ROOM:
    '/v2/proctors/:proctorAccountSid/locations/:proctorAccountLocationSid/rooms/:roomSid/proctors',
  EXIT_ROOM:
  '/v2/proctors/:proctorAccountSid/locations/:proctorAccountLocationSid/rooms/:roomSid/proctors',
};

export const ROUTES = {
  LOGIN: '/vtc',
  AUTO_LOGIN: '/vtc',
  ROOMS: '/vtc/rooms',
  ROOM: '/vtc/rooms/:roomSid',
  CHECKIN_FOCUS: '/vtc/rooms/:roomSid/checkin/:sessionSid',
  SESSION_FOCUS: '/vtc/rooms/:roomSid/focus/:sessionSid',
  SETTINGS: '/vtc/rooms/:roomSid/settings',
  CHECKIN: '/vtc/rooms/:roomSid/checkin',
  SCHEDULE: '/vtc/rooms/:roomSid/schedule',
  OPTIONS: '/vtc/rooms/:roomSid/options',
};

export { config }
export default config;
